<script lang="ts">
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import { getYotpoPreview, type YotpoPreview } from '$lib/review/preview';
	import StarRating from '$lib/review/starRating.svelte';

	interface Props {
		theme?: 'yellow' | 'brown';
	}

	let { theme = 'yellow' }: Props = $props();

	let preview = $state<YotpoPreview>();
</script>

<div
	class={['flex items-center gap-x-2', { 'blur-sm': !preview }]}
	use:checkVisibility={{ threshold: 0 }}
	onvisible={async ({ detail }) => {
		if (!detail || preview) return;

		preview = await getYotpoPreview();
	}}
	itemprop="aggregateRating"
	itemscope
	itemtype="https://schema.org/AggregateRating"
>
	{#if preview}
		<StarRating {theme} score={preview.averageScore} totalStars={5} starClass="h-4 w-4" />

		<a
			href="#reviews-widget"
			class="text-nowrap text-[16px]/[150%] tracking-[-.16px] text-brown-1 underline underline-offset-[32%]"
		>
			<span itemprop="ratingValue">{preview.averageScore}</span>{#if theme === 'yellow'}/<span
					itemprop="bestRating">5</span
				>{/if}
			<span class={{ hidden: theme !== 'brown' }}>
				(<span itemprop="reviewCount">{preview.totalReviews}</span>)
			</span>
		</a>
	{:else}
		<StarRating {theme} score={5} totalStars={5} starClass="h-4 w-4" />
		<p class="text-[16px]/[150%] tracking-[-.16px] text-brown-2 underline">4.95/5</p>
	{/if}
</div>

<style lang="scss">
	a.underline {
		text-decoration-skip-ink: auto;
		text-decoration-thickness: 8%;
		text-underline-position: from-font;
	}
</style>
